import { PromotionsStylesSchema } from './Promotions.styles';

export const promotionsStyles: PromotionsStylesSchema = {
  heading: {
    mb: '2',
    color: 'gray.700',
    fontWeight: '700',
  },
  promotionWrapper: {
    p: '4',
    bg: 'alpha.50',
    my: '3',
    boxShadow: 'lg',
    borderRadius: 'md',
    borderColor: 'alpha.200',
    borderWidth: '1px',
  },
  flexWrapper: { gap: '4', pt: '4', justifyContent: 'space-between' },
  termsAndConditions: {
    color: 'gray.700',
    fontSize: 'sm',
    pt: '1',
  },
};
